module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-arrow-up-0d4812f7.svg";